module.exports = __webpack_public_path__ + "img/logo.5185646b.png";